export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "talk-JitsiStreamBackgroundEffect.worker.worker.js?v=9e8c0caa911461d366e6");
}
